import React from 'react';
import { toast } from 'react-toastify';
import { Input } from '@progress/kendo-react-inputs';
import services from '../../services';
import { Button } from '@progress/kendo-react-buttons'
var moment = require('moment')


class BoletimArtigoForm extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            telkikTable: "",
            Comment: '',
            moduleData: []
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.setMainState()
    }
    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            this.setMainState()
        }
    }
    setMainState = () => {
        // console.log(this.props);

        this.setState({
            data: this.props.data ? this.props.data : {},
            moduleData: this.props.moduledata
        });
    }

    handleChange = (e) => {
        let data = { ...this.state.data }
        if (e.target.name === 'pctcasta' && (Number(e.target.value) < 0 || Number(e.target.value) > 100)) {
            toast.error("A Porcentagem nunca deve ser menor que 0 ou maior que 100")
            return;
        }
        if (!e.target.value) {
            delete data[e.target.name]
        } else
            data[e.target.name] = isNaN(e.target.value) ? '' : e.target.value;

        this.setState({
            data
        })
    }

    handleDate = (e) => {
    let data = { ...this.state.data }
    data['startDate'] = e && e._d && moment(e._d).format('MM-DD-YYYY')
    this.setState({
        data
    })
    }

    Submitform = () => {
    let data = { ...this.state.data }
    let error = null;
    let errors = {};
    if (this.props.moduledata) {
        let index = (this.state.moduleData).length
        let dataarray = [...this.state.moduleData];
        dataarray[index] = data;
        if (this.props.tab == "boletimArtigoMatricial") {
            let numArtigo = Number(data.numArtigo);
            console.log(numArtigo);
            if (isNaN(numArtigo)) {
                // if ( !(data.numArtigo > 0) || data.numArtigo=== " " ) {
                errors.numArtigo = {
                    "numArtigo": ["Nº Artigo parte deve estar em Fração ou Inteiro"]
                }
            }
            if (Object.keys(errors).length > 0) {
                error = {
                    errors: errors
                }
                services.errorCheck.error(error);
                return;
            }
        }
        if (!error)
                this.props.getpopUpdata(dataarray, this.props.tab);
            else
                services.errorCheck.error(error);

        } else {

            this.props.getpopUpdata(data, this.props.tab);
        }
        if (!error)
            this.props.closeForm();
    }
    render(){
        return(
            <div className="bg-white middle p20 mt-140 container my-2">
                <div className="container-header d-flex justify-content-between">
                    <h4 className="pl-0">Inserir Artigo Matricial</h4>
                    <div className="pull-right">
                        <Button primary={true} onClick={() => this.Submitform()} className="btn-ivdp-primary btn-sm text-uppercase mr-3">Guardar</Button>
                        <Button onClick={() => this.props.closeForm()} className="remoove cursor-pointer mr-2 k-primary btn-ivdp-secondary btn-theme">Cancelar</Button>
                    </div>
                    
                </div>
                <div className="">
                    <div className="details row">
                        <div className="col-md-6">
                            <div className="input-box active-grey mb-2">
                                <Input
                                    type="text"
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    name="numArtigo"
                                    value={this.state.data.numArtigo || ""}
                                    label="Nº Artigo"
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="input-box active-grey mb-2">
                                <Input
                                    type="text"
                                    maxLength={1}
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    name="fraccao"
                                    value={this.state.data.fraccao || ""}
                                    label="Fração"
                                    onChange={(e) => this.handleChange(e)}
                                />
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        )
    }
}

export default BoletimArtigoForm;
